import { createContext, ReactNode, FC } from 'react';

type CheckoutServerVarsContext = {
    isMobile: boolean;
    isInReturningBuyerShippingVariant: boolean;
    isEnhancedBuyerIncentivesClientVariant: boolean;
};

export const CheckoutServerVarsContext = createContext<CheckoutServerVarsContext>({
    isMobile: false,
    isInReturningBuyerShippingVariant: false,
    isEnhancedBuyerIncentivesClientVariant: false,
});

type Props = {
    children: ReactNode;
    isMobile: boolean;
    isInReturningBuyerShippingVariant: boolean;
    isEnhancedBuyerIncentivesClientVariant: boolean;
};

export const CheckoutServerVarsContextProvider: FC<Props> = ({
    children,
    isMobile,
    isInReturningBuyerShippingVariant,
    isEnhancedBuyerIncentivesClientVariant,
}) => (
    <CheckoutServerVarsContext.Provider
        value={{
            isMobile,
            isInReturningBuyerShippingVariant,
            isEnhancedBuyerIncentivesClientVariant,
        }}
    >
        {children}
    </CheckoutServerVarsContext.Provider>
);
